import BadgeNumbers from "@/Components/UI/BadgeNumbers";
import classNames from "@/utils/classNames";
import { KeyboardEvent, MouseEvent, ReactNode } from "react";
import { IconType } from "react-icons";

export type NavButtonActivationEvent =
    | MouseEvent<HTMLDivElement>
    | KeyboardEvent<HTMLDivElement>;

type NavBarButtonProps = {
    icon: IconType;
    name: string;
    selected: boolean;
    badgeNumbers?: number[];
    onActivate: (e: NavButtonActivationEvent) => void;
    tooltip?: ReactNode;
};

export default function NavBarButton({
    icon: Icon,
    name,
    selected,
    badgeNumbers,
    onActivate,
    tooltip,
}: NavBarButtonProps) {
    return (
        <div
            data-testid={`mobile-${name.replace(/\s+/g, "-").toLowerCase()}`}
            className={classNames(
                "flex w-0 grow flex-col items-center justify-center transition-transform active:scale-95",
                selected ? "text-brand-red" : "text-brand-black",
            )}
            onClick={onActivate}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && onActivate(e)}
        >
            <div className="relative">
                {tooltip}
                <Icon className="my-2 cursor-pointer rounded-md text-2xl" />
                {badgeNumbers && (
                    <BadgeNumbers
                        badgeNumbers={badgeNumbers}
                        badgeStyles={[
                            "-right-[12px] top-[2px] text-brand-white bg-brand-red",
                            "-right-[24px] top-[2px] text-brand-white bg-brand-dangerOrange",
                        ]}
                    />
                )}
            </div>
            <div className="text-xs">{name}</div>
        </div>
    );
}
